
class OffcanvasComponent extends HTMLElement {
  static portalRootId = 'offcanvas-portal-root';

  #controller = new AbortController();
  #instance = null;

  connectedCallback() {
    const { signal } = this.#controller;
    console.log("test");
    document.addEventListener('click', this.#handleDocumentClick, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /* =====================
   * PORTAL
   * ===================== */

  static getPortalRoot() {
    let root = document.getElementById(this.portalRootId);
    if (!root) {
      root = document.createElement('div');
      root.id = this.portalRootId;
      document.body.appendChild(root);
    }
    return root;
  }

  get id() {
    return this.dataset.offcanvas;
  }

  get isPortalInstance() {
    return this.dataset.offcanvasInstance === 'true';
  }

  /* =====================
   * EVENTS
   * ===================== */

  #handleDocumentClick = (e) => {
    const open = e.target.closest('[data-offcanvas-open]');
    const close = e.target.closest('[data-offcanvas-close]');

    // OPEN
    if (open && open.dataset.offcanvasOpen === this.id) {
      e.preventDefault();
      this.open();
    }

    // CLOSE (solo sull’istanza portale)
    if (close && this.#instance && this.#instance.contains(close)) {
      e.preventDefault();
      this.close();
    }
  };

  /* =====================
   * API
   * ===================== */

  open() {
    if (this.#instance) {
      this.#instance.classList.add('is-open');
      return;
    }

    const portalRoot = OffcanvasComponent.getPortalRoot();

    const clone = this.cloneNode(true);
    clone.dataset.offcanvasInstance = 'true';

    portalRoot.appendChild(clone);

    this.#instance = clone;

    requestAnimationFrame(() => {
      clone.classList.add('is-open');
      document.body.classList.add('offcanvas-open');
    });
  }

  close() {
    if (!this.#instance) return;

    this.#instance.classList.remove('is-open');
    document.body.classList.remove('offcanvas-open');

    // opzionale: rimuovere dal DOM dopo animazione
    this.#instance.addEventListener(
      'transitionend',
      () => {
        this.#instance?.remove();
        this.#instance = null;
      },
      { once: true }
    );
  }
}

if (!customElements.get('offcanvas-component')) {
  customElements.define('offcanvas-component', OffcanvasComponent);
}
